import { useSyncExternalStore } from 'react';
import packageJson from '../../package.json';

export const runningAppVersion = Object.freeze({
  version: packageJson.version,
  buildId: import.meta.env.VITE_QRMAPS_BUILD_ID || 'development',
});
export function getUpdateSupportMessage() {
  if (!import.meta.env.PROD) {
    return 'Development mode: deployment updates are disabled. Local code changes are applied by the development server.';
  }
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return 'In-app updates are not supported in this browser. Save your work and reload the page to load the latest version.';
  }
  return '';
}
let state = { available: null, checking: false, applying: false, error: '', checked: false };
const listeners = new Set();
export const getAppUpdateState = () => state;
export function setAppUpdateState(patch) {
  state = { ...state, ...patch };
  listeners.forEach((listener) => listener());
}
export function useAppUpdateState() {
  return useSyncExternalStore((listener) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  }, getAppUpdateState, getAppUpdateState);
}
export function updateKey(update) {
  return update ? `${update.version}:${update.buildId}` : '';
}
export function isUpdateDismissed(update) {
  try { return localStorage.getItem('cruisingos:dismissed-update') === updateKey(update); }
  catch { return false; }
}
export function dismissAppUpdate(update) {
  try { localStorage.setItem('cruisingos:dismissed-update', updateKey(update)); } catch { /* Optional storage. */ }
  setAppUpdateState({});
}
